import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, inject, PropType, ref } from "vue";
import { PPTChartElement } from "@/types/slides";
import { injectKeySlideScale } from "@/types/injectKey";

import ElementOutline from "@/views/components/element/ElementOutline.vue";
import Chart from "./Chart.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  elementInfo: {
    type: Object as PropType<PPTChartElement>,
    required: true,
  },
},
  setup(__props) {



const slideScale = inject(injectKeySlideScale) || ref(1);

const needScaleSize = computed(() => slideScale.value < 1);
const zoom = computed(() => (needScaleSize.value ? 1 / slideScale.value : 1));



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-chart",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          backgroundColor: __props.elementInfo.fill,
        })
      }, [
        _createVNode(ElementOutline, {
          width: __props.elementInfo.width,
          height: __props.elementInfo.height,
          outline: __props.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode(Chart, {
          width: __props.elementInfo.width * _unref(zoom),
          height: __props.elementInfo.height * _unref(zoom),
          type: __props.elementInfo.chartType,
          data: __props.elementInfo.data,
          options: __props.elementInfo.options,
          themeColor: __props.elementInfo.themeColor,
          gridColor: __props.elementInfo.gridColor,
          legends: __props.elementInfo.data.legends,
          legend: __props.elementInfo.legend || '',
          style: _normalizeStyle({ zoom: 1 / _unref(zoom) })
        }, null, 8, ["width", "height", "type", "data", "options", "themeColor", "gridColor", "legends", "legend", "style"])
      ], 4)
    ], 4)
  ], 4))
}
}

})